module.exports = __webpack_public_path__ + "media/images/business/bg-outline_circle-8d40d68931526efef664a9e831c05cc4.svg";